var INFO_BEHAVIOUR_ON_HOVER = {
  APPEARS: 'APPEARS',
  DISAPPEARS: 'DISAPPEARS',
  NO_CHANGE: 'NO_CHANGE',
  //ALWAYS_SHOW
  NEVER_SHOW: 'NEVER_SHOW'
};
export default INFO_BEHAVIOUR_ON_HOVER;